
import { useEffect } from 'react';
import { useProducts } from '../../hooks/useProducts';

function hexToRgb(hex: string): string {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    if (!result) return '37 99 235';
    return `${parseInt(result[1], 16)} ${parseInt(result[2], 16)} ${parseInt(result[3], 16)}`;
}

const BrandThemeInjector: React.FC = () => {
    const { brandingSettings } = useProducts();

    useEffect(() => {
        const primaryRgb = hexToRgb(brandingSettings.primaryColor);
        const secondaryRgb = hexToRgb(brandingSettings.secondaryColor);

        document.documentElement.style.setProperty('--brand-primary', primaryRgb);
        document.documentElement.style.setProperty('--brand-secondary', secondaryRgb);
    }, [brandingSettings.primaryColor, brandingSettings.secondaryColor]);

    useEffect(() => {
        if (!brandingSettings.faviconUrl) return;
        let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement | null;
        if (!link) {
            link = document.createElement('link');
            link.rel = 'icon';
            document.head.appendChild(link);
        }
        link.href = brandingSettings.faviconUrl;
    }, [brandingSettings.faviconUrl]);

    useEffect(() => {
        if (brandingSettings.platformName) {
            const currentTitle = document.title;
            if (currentTitle.includes('Impresión Veloz')) {
                document.title = currentTitle.replace('Impresión Veloz', brandingSettings.platformName);
            }
        }
    }, [brandingSettings.platformName]);

    return null;
};

export default BrandThemeInjector;
